import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { EMAIL, PHONE, PHONE_HREF } from "@/lib/site";

export const Footer = () => (
    <footer className="border-t border-[#2E2517] bg-[#120E09]" data-testid="footer">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 py-16 md:grid-cols-3">
            <div>
                <Logo />
                <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#9C917D]">
                    Brennholz, Bauholz und forstwirtschaftliche Dienstleistungen — aus der Region, für die Region.
                </p>
            </div>
            <div>
                <p className="mb-4 text-xs uppercase tracking-[0.25em] text-[#C88A45]">Kontakt</p>
                <a href={PHONE_HREF} className="block text-sm text-[#EDE6DA] transition-colors duration-200 hover:text-[#C88A45]">{PHONE}</a>
                <a href={`mailto:${EMAIL}`} className="mt-2 block text-sm text-[#EDE6DA] transition-colors duration-200 hover:text-[#C88A45]">{EMAIL}</a>
            </div>
            <div>
                <p className="mb-4 text-xs uppercase tracking-[0.25em] text-[#C88A45]">Einsatzgebiet</p>
                <p className="text-sm leading-relaxed text-[#9C917D]">Von der Uckermark über Berlin bis zur Mecklenburgischen Seenplatte — Lieferung bis ca. 150 km ab Templin.</p>
            </div>
        </div>
        <div className="border-t border-[#2E2517]">
            <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-6 py-6 text-xs text-[#9C917D]">
                <span>© {new Date().getFullYear()} KischioWood</span>
                <span className="flex items-center gap-5">
                    <Link data-testid="footer-impressum-link" to="/impressum" className="transition-colors duration-200 hover:text-[#C88A45]">
                        Impressum
                    </Link>
                    <Link data-testid="footer-datenschutz-link" to="/datenschutz" className="transition-colors duration-200 hover:text-[#C88A45]">
                        Datenschutz
                    </Link>
                    <Link data-testid="footer-admin-link" to="/admin/login" className="transition-colors duration-200 hover:text-[#C88A45]">
                        Login
                    </Link>
                </span>
            </div>
        </div>
    </footer>
);
